import { Label, RadioGroup, RadioGroupItem } from '@startupquickstart/frontend';
import { Smartphone, QrCode } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface RedemptionTypeSelectorProps {
  value?: 'self' | 'barcode';
  onChange: (value: 'self' | 'barcode') => void;
}

const redemptionOptions = [
  {
    value: 'self' as const,
    icon: Smartphone,
    title: 'Self-Service',
    description: 'User taps a button in the app to redeem',
  },
  {
    value: 'barcode' as const,
    icon: QrCode,
    title: 'Barcode Scan',
    description: 'Staff scans user\'s barcode to redeem',
  },
];

export function RedemptionTypeSelector({ value, onChange }: RedemptionTypeSelectorProps) {
  return (
    <RadioGroup
      value={value ?? 'barcode'}
      onValueChange={(val) => onChange(val as 'self' | 'barcode')}
      className="grid gap-3 sm:grid-cols-2"
    >
      {redemptionOptions.map((option) => {
        const Icon = option.icon;
        const isSelected = value === option.value || (!value && option.value === 'barcode');

        return (
          <Label
            key={option.value}
            htmlFor={`redemption-${option.value}`}
            className={cn(
              'flex cursor-pointer items-start gap-4 rounded-xl border p-4 transition-all',
              'hover:border-primary/50 hover:bg-muted/50',
              isSelected
                ? 'border-primary bg-primary/5 ring-1 ring-primary/20'
                : 'border-border bg-card',
            )}
          >
            <RadioGroupItem
              value={option.value}
              id={`redemption-${option.value}`}
              className="mt-0.5 shrink-0"
            />
            <div className="flex flex-1 items-start gap-3">
              <div
                className={cn(
                  'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg',
                  isSelected
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground',
                )}
              >
                <Icon className="h-5 w-5" />
              </div>
              <div className="flex-1 space-y-1">
                <div className={cn('font-medium', isSelected && 'text-primary')}>
                  {option.title}
                </div>
                <div className="text-sm text-muted-foreground">{option.description}</div>
              </div>
            </div>
          </Label>
        );
      })}
    </RadioGroup>
  );
}
